<template>
    <Drag class="emap-thematic-table" @on-close="onClose" v-show="isShow">
        <div slot="title">统计表</div>
        <div
            slot="content"
            style="height: 250px; width: 460px;"
            @mouseover="currentChange1"
        >
            <div style="margin-bottom: 5px;">
                <span>专题：</span>
                <i-Select
                    style="width: 150px;"
                    size="small"
                    v-model="planId"
                    @on-change="onPlanChange"
                >
                    <i-Option
                        v-for="(item, i) in plans"
                        :key="i"
                        :value="item.planId"
                    >
                        {{ item.title }}
                    </i-Option>
                </i-Select>
            </div>
            <i-Table
                height="220"
                size="large"
                border
                highlight-row
                :columns="columns1"
                :data="data1"
                ref="thematicTable"
                @on-row-click="currentChange"
                style="cursor: default;"
            ></i-Table>
        </div>
    </Drag>
</template>

<script>
import Drag from '@/components/Drag.vue';

import { getFeatureValues } from '@/utils/serviceUtil/wfsUtil.js';
import { queryDPS } from '@/utils/serviceUtil/dpsUtil.js';
import { queryDQS } from '@/utils/serviceUtil/dqsUtil.js';
import { getDispatcher } from '@/utils/analysisTools/';
import WFSBean from '@/utils/analysisTools/beans/WFSBean';

import { eventMgr } from './events';
import {MiscUtil} from "../../../utils/miscUtil";
let popup
export default {
    components: { Drag },
    unwatch() {
        return {
            clusterData: [],
        };
    },
    inject: ['MapView'],
    data() {
        return {
            columns1: [],
            data1: [],
            matchField: '',
            eventName: '',
            isShow: true,
            plan: {},
            plans: [],
            plansTt: [],
            planId: null,
            allFeatures:[],
            popup: null
        };
    },
    beforeDestroy() {
        eventMgr.off('switchTableDisplay', this.switchDisplay);
        eventMgr.off('addTablePlan', this.addTablePlan);
        eventMgr.off('removeTablePlan', this.removeTablePlan);
        eventMgr.off('updateClusterData', this.updateClusterData);
        eventMgr.off('changeTablePlan', this.changeTablePlan);
        eventMgr.off('changeTableSelect', this.changeTablePlan);
        eventMgr.off('changeTableSelect', this.changeTableSelect);
        eventMgr.off('getAllClusterData', this.getAllClusterData)
        this.removePopup()
    },
    mounted() {
        eventMgr.on('switchTableDisplay', this.switchDisplay);
        eventMgr.on('addTablePlan', this.addTablePlan);
        eventMgr.on('removeTablePlan', this.removeTablePlan);
        eventMgr.on('updateClusterData', this.updateClusterData);
        eventMgr.on('changeTablePlan', this.changeTablePlan);
        eventMgr.on('changeTableSelect', this.changeTableSelect);
        // 获取所有数据
        eventMgr.on('getAllClusterData', this.getAllClusterData)
    },
    methods: {
        addTablePlan(planInfo) {
            this.plan = planInfo;
            this.plans.push(this.plan);
            this.plansTt.push(this.plan);
            this.planId = this.plan.planId;
            this.showPlan();
        },
        showPlan() {
            this.plan = this.plansTt.find(plan => {
                return this.planId === plan.planId;
            });
            if (this.plan) {
                const model = this.plan.configcont.basic.model;
                if (model === 'Charts') {
                    switch (this.plan.configcont.thematic.serviceType) {
                        case 'WFS':
                            this.wfsPlan();
                            break;
                        case 'DPS':
                            this.dpsPlan();
                            break;
                        case 'DQS':
                            this.dqsPlan();
                            break;
                        default:
                            break;
                    }
                }
                if (model === 'Clusters') {
                    this.clustersLayerPlan();
                }
            }
        },
        removeTablePlan(planId) {
            const index = this.plans.findIndex(plan => {
                return plan.planId === planId;
            });
            if (index > -1) {
                if (this.plans[index].planId === this.planId) {
                    if (this.plans.length === 1) {
                        this.$CompManager.remove(this);
                    } else {
                        this.plans.splice(index, 1);
                        this.plan = this.plans[this.plans.length - 1];
                        this.planId = this.plan.planId;
                        this.showPlan();
                        // this.onPlanChange(this.planId)
                    }
                } else {
                    this.plans.splice(index, 1);
                }
            }
        },
        //主动切换方案
        onPlanChange(val) {
            this.plan = this.plansTt.find(plan => {
                return val === plan.planId;
            });
            const params = {};
            if (this.plan.configcont.basic.model === 'Clusters') {
                eventMgr.fire('switchChartDisplay', false);
            } else {
                eventMgr.fire('switchChartDisplay', true);
                params.title = this.plan.configcont.thematic.mapMatchField;
                params.value = this.plan.configcont.thematic.mapQueryField;
            }
            // eventMgr.fire('changeChartPlan', this.planId)
            this.showPlan();
            params.id = this.planId;
            params.eventName = 'table';
            eventMgr.fire('changeChartsPlan', params);
        },
        //被动切换方案
        changeTablePlan(evt) {
            if (evt.eventName !== 'table') {
                if (this.planId !== evt.id) {
                    this.planId = evt.id;
                    this.showPlan();
                }
            }
        },
        clustersLayerPlan() {
            const wfsUrl = this.plan.configcont.thematic.serviceUrl;
            const typeName = this.plan.configcont.thematic.serviceLayer;
            const id = this.plan.planId;
            const queryParams = {
                url: wfsUrl,
                layerName: typeName,
            };
            const bean = new WFSBean(queryParams);
            getDispatcher(this)
                .read(bean)
                .then(result => {
                    const features = result.geojson;
                    const _features = features.map(feature => {
                        feature.properties['_planId'] = id;
                        return feature;
                    });
                    this.updateClusterData(_features.slice(0, 9));
                });
        },
        wfsPlan() {
            let wfsUrl = this.plan.configcont.thematic.serviceUrl;
            // wfsUrl= MiscUtil.getProxyUrl(wfsUrl)
            if (this.plan && wfsUrl !== '') {
                const typeName = this.plan.configcont.thematic.serviceLayer;
                let fieldString = '';
                const columns = [{ title: '序号', key: 'id', width:100 }];
                // console.log(fields, 'fields');
                const fields = this.plan.configcont.thematic.serviceTableFields;
                this.matchField = this.plan.configcont.thematic.serviceQueryField;
                for (let i = 0; i < fields.length; i++) {
                    if (i === fields.length - 1) {
                        fieldString = fieldString + fields[i].name;
                    } else {
                        fieldString = fieldString + fields[i].name + ',';
                    }
                    columns.push({
                        title: fields[i].alias,
                        key: fields[i].name,
                    });
                }
                this.columns1 = columns;
                const _this = this;
                getFeatureValues(wfsUrl, typeName, fieldString).then(data => {
                    if (data.length > 0) {
                        const datatemp = [];
                        for (let i = 0; i < data.length; i++) {
                            const temp = {};
                            for (let j = 0; j < _this.columns1.length; j++) {
                                if (_this.columns1[j].key === 'id') {
                                    temp[_this.columns1[j].key] = i + 1;
                                } else {
                                    temp[_this.columns1[j].key] =
                                        data[i].data[_this.columns1[j].key];
                                }
                            }
                            datatemp.push(temp);
                        }
                        _this.data1 = datatemp;
                    }
                });
            }
        },
        dpsPlan() {
            const url = this.plan.configcont.thematic.serviceUrl;
            const dataSetId = this.plan.configcont.thematic.dataSetId;
            let fieldString = '';
            const columns = [{ title: '序号', key: 'id', width:100 }];
            const fields = this.plan.configcont.thematic.serviceTableFields;
            this.matchField = this.plan.configcont.thematic.serviceQueryField;
            const colFilter = [];
            for (let i = 0; i < fields.length; i++) {
                if (i === fields.length - 1) {
                    fieldString = fieldString + fields[i].name;
                } else {
                    fieldString = fieldString + fields[i].name + ',';
                }
                columns.push({
                    title: fields[i].alias,
                    key: fields[i].name,
                });
                colFilter.push(fields[i].name);
            }
            this.columns1 = columns;
            const _this = this;
            queryDPS(url, dataSetId, colFilter).then(data => {
                if (data.features) {
                    const features = data.features;
                    const datatemp = [];
                    for (let i = 0; i < features.length; i++) {
                        const temp = {};
                        for (let j = 0; j < _this.columns1.length; j++) {
                            if (_this.columns1[j].key === 'id') {
                                temp[_this.columns1[j].key] = i + 1;
                            } else {
                                temp[_this.columns1[j].key] =
                                    features[i].attributes[
                                        _this.columns1[j].key
                                    ];
                            }
                        }
                        datatemp.push(temp);
                    }
                    _this.data1 = datatemp;
                }
            });
        },
        dqsPlan() {
            const url = this.plan.configcont.thematic.serviceUrl;
            let fieldString = '';
            const columns = [{ title: '序号', key: 'id', width:100 }];
            const fields = this.plan.configcont.thematic.serviceTableFields;
            this.matchField = this.plan.configcont.thematic.serviceQueryField;
            const colFilter = [];
            for (let i = 0; i < fields.length; i++) {
                if (i === fields.length - 1) {
                    fieldString = fieldString + fields[i].name;
                } else {
                    fieldString = fieldString + fields[i].name + ',';
                }
                columns.push({
                    title: fields[i].alias,
                    key: fields[i].name,
                });
                colFilter.push(fields[i].name);
            }
            this.columns1 = columns;
            const _this = this;
            queryDQS(url, colFilter).then(data => {
                if (data.features) {
                    const features = data.features;
                    const datatemp = [];
                    for (let i = 0; i < features.length; i++) {
                        const temp = {};
                        for (let j = 0; j < _this.columns1.length; j++) {
                            if (_this.columns1[j].key === 'id') {
                                temp[_this.columns1[j].key] = i + 1;
                            } else {
                                temp[_this.columns1[j].key] =
                                    features[i].attributes[
                                        _this.columns1[j].key
                                    ];
                            }
                        }
                        datatemp.push(temp);
                    }
                    _this.data1 = datatemp;
                }
            });
        },
        updateClusterData(features) {
            if (
                features.length > 0 &&
                features[0].properties['_planId'] &&
                features[0].properties['_planId'] === this.planId
            ) {
                const columns = [{ title: '序号', key: 'id', width:100 }];
                this.plan.configcont.thematic.displayFields.map(item => {
                    columns.push({
                        title: item.alias,
                        key: item.name,
                    });
                });
                // columns.push(
                //     {
                //         title: this.plan.configcont.thematic.showField,
                //         key: this.plan.configcont.thematic.showField,
                //     },
                //     {
                //         title: this.plan.configcont.thematic.valueField,
                //         key: this.plan.configcont.thematic.valueField,
                //     }
                // );
                this.matchField = '';
                this.columns1 = columns;
                const _this = this;
                if (features.length > 0) {
                    const datatemp = [];
                    for (let i = 0; i < features.length; i++) {
                        const temp = {};
                        for (let j = 0; j < _this.columns1.length; j++) {
                            if (_this.columns1[j].key === 'id') {
                                temp[_this.columns1[j].key] = i + 1;
                            } else {
                                temp[_this.columns1[j].key] =
                                    features[i].properties[
                                        _this.columns1[j].key
                                    ];
                            }
                        }
                        datatemp.push(temp);
                    }
                    _this.data1 = datatemp;
                }
            }
        },
        currentChange(row) {
            let index = -1
            let filed = ''
            let value = ''
            for (const key in row) {
                index += 1
                if(index == 1){
                    filed = key
                    value = row[key]
                }
            }
            if(this.allFeatures.length > 0){
                console.log(this.allFeatures, this.plan,this.columns1, "this.allFeatures, this.columns1, this.plan")
                let allFeatures = this.allFeatures.filter(item => item.id == this.plan.planId)[0].data
                let filter = allFeatures.filter(item => item.properties[filed] == value)
                if(filter.length > 0){
                    let center = filter[0].geometry.coordinates
                    this.MapView.map.flyTo({center,zoom: 17})
                    this.openPopup(row, center, filter[0].properties)
                }
            }
            if (row[this.matchField]) {
                const params = row[this.matchField];
                params.eventName = 'table';
                eventMgr.fire('changeChartsSelect', params);
            }
        },
        openPopup(data,center,properties){
            this.removePopup()
            let str = ''
            let i = -1
            for (const key in data) {
                i++
                if(key != 'id'){
                    str += `<div style='margin:6px 10px'>${this.columns1[i].title} : ${data[key]}</div>`
                }
            }
            popup = new mapboxgl.Popup({className: 'my-class',closeButton:false})
            .setLngLat(center)
            .setHTML(str)
            .addTo(this.MapView.map);
        },
        removePopup(){
            if(popup){
                popup.remove()
                popup = null
            }
        },
        //统计表hover事件监听
        currentChange1() {
            this.$nextTick(() => {
                if (this.$refs.thematicTable) {
                    const field = this.matchField;
                    const data = this.$refs.thematicTable._data.objData;
                    let currentIndex = -1;
                    Object.keys(data).forEach(key => {
                        if (data[key]._isHover === true) {
                            currentIndex = parseInt(key);
                        }
                    });
                    if (currentIndex > -1) {
                        this.$refs.thematicTable.highlightCurrentRow(
                            currentIndex
                        );
                        const params = {};
                        params.title = this.plan.configcont.thematic.mapMatchField;
                        params.value = this.plan.configcont.thematic.mapQueryField;
                        params.name = data[currentIndex][field];
                        params.eventName = 'table';
                        eventMgr.fire('changeChartsSelect', params);
                    }
                }
            });
        },
        changeTableSelect(evt) {
            if (evt.eventName !== 'table') {
                const currentIndex = this.data1.findIndex(
                    value => value[this.matchField] === evt.name
                );
                if (currentIndex > -1) {
                    this.$refs.thematicTable.highlightCurrentRow(currentIndex);
                    let top = 0;
                    for (let i = 0; i < currentIndex; i++) {
                        top += this.$refs.thematicTable.$children[1].$children[0].$el.getBoundingClientRect()
                            .height;
                    }
                    this.$refs.thematicTable.$refs.body.scrollTop = top;
                }
            }
        },
        switchDisplay(show) {
            if (show !== undefined) {
                this.isShow = show;
            } else {
                this.isShow = !this.isShow;
            }
        },
        onClose() {
            this.isShow = false;
        },
        getAllClusterData(features, planId){
            this.allFeatures.push({
                id: planId,
                data: features
            })
        }
    },
};
</script>
